module.exports = __webpack_public_path__ + "img/24.90e59e4f.png";